export default __webpack_public_path__ + "assets/chat-notification-vianova.mp3";